import {forkJoin, Observable} from 'rxjs';
import {ResolveFn} from '@angular/router';
import {resolveGovernmentName} from '../../../services/resolvers/government-name.resolver';
import {map} from 'rxjs/operators';
import {resolveFinancialHealthIndicator} from './financial-health-indicator.resolver.service';

export const financialHealthIndicatorTitleResolver: ResolveFn<string> = (route) => {
	const mcag = route.paramMap.get('mcag');
	let resolveGovernmentTitle: Observable<string> | undefined = undefined;

	if (mcag) {
		resolveGovernmentTitle = resolveGovernmentName(route);
	}

	// for browser title, history
	if (resolveGovernmentTitle) {
		return forkJoin([resolveGovernmentTitle, resolveFinancialHealthIndicator(route)]).pipe(
			map(([govTitle, financialHealthIndicator]) => {
				if (financialHealthIndicator === null) {
					return `${govTitle}`;
				} else {
					return `${govTitle}: ${financialHealthIndicator.subTitle}, ${financialHealthIndicator.title}`;
				}
			})
		);
	} else {
		throw Error('Financial Health Indicator title not able to resolve for government');
	}
};
